module.exports = __webpack_public_path__ + "img/xnr6.c97c0148.png";